<template lang="html">
    <div class="maint">
        <!-- banner -->
        <div class="banner-img">
            <!-- <img width="100%" src="https://static.qyjmed.com/webSite/productService/maint/banner-img.png" alt=""> -->
            <div class="container">
                <div class="soft-img">
                    <div class="soft">
                        <img src="https://static.qyjmed.com/webSite/productService/maint/detection1.png" alt="">
                        <p>实时监控</p>
                    </div>
                    <div class="soft">
                        <img src="https://static.qyjmed.com/webSite/productService/maint/detection2.png" alt="">
                        <p>耗材管理</p>
                    </div>
                    <div class="soft">
                        <img src="https://static.qyjmed.com/webSite/productService/maint/detection3.png" alt="">
                        <p>效益分析</p>
                    </div>
                    <div class="soft">
                        <img src="https://static.qyjmed.com/webSite/productService/maint/detection4.png" alt="">
                        <p>工作提醒</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="cc">
            <div class="container">
                <div class="cc-box">
                    <div data-wow-delay="1s" class="wow bounceInLeft cc-text">
                        <i></i>
                        <p>公司致力于为全国医院提供专业优质的服务，为医疗设备提供检测、保养、维修、保修等服务，服务范围涵盖国内外各大品牌各类设备，包括超声、普放、CT、核磁、直线加速器、内窥镜、呼吸机、麻醉机等等。</p>
                        <p>我们拥有一支经过综合培训的优秀工程师队伍，以及业内专业的客服团队。我们始终站在客户角度，想客户之所想急客户之所急，帮客户之所需，解除客户后顾之忧，旨在为客户提供细致、周到、及时的服务，能够为医院提供定制化服务方案。</p>
                        <p>我们能够提供全面、经济、快速的服务给客户。客户的满意是我们的毕生追求。我们将秉承“专注专业、优质优服、诚信共赢”的经营理念不断超越自己，稳步发展！</p>
                    </div>
                    <div class="cc-img">
                        <img data-wow-delay="1s" class=" wow bounceInRight" src="https://static.qyjmed.com/webSite/aboutUs/cc/cc.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <!-- 分类 -->
        <h2>设备保修分类</h2>
        <div class="classfiy">
            <div class="container">

                <div class="classfiy-box">
                    <img src="https://static.qyjmed.com/webSite/productService/maint/one.png" alt="">
                    <h2>技术保</h2>
                    <p>免费上门对设备进行检测维修(不涉及更换任何配件)</p>
                </div>
                <div class="classfiy-box">
                    <img src="https://static.qyjmed.com/webSite/productService/maint/two.png" alt="">
                    <h2>银保</h2>
                    <p>对设备无限次上门检测维修<br>免费更换无法修复的配件<br>(不含探头)</p>
                </div>
                <div class="classfiy-box">
                    <img src="https://static.qyjmed.com/webSite/productService/maint/three.png" alt="">
                    <h2>全保</h2>
                    <p>无限次故障检测维修<br>免费更换无法修复的配件<br>(含探头)</p>
                </div>
            </div>
        </div>
        <!-- 服务承诺 -->
        <div class="promise">
            <div class="container">
                <h2>服务承诺</h2>
                <!-- <div class="promise-box" @mouseenter='mouseOver(index)' v-for="item in option">
                    <img :src="item.img" alt="">
                    <h2>{{item.title}}</h2>
                    <p>{{item.content}}</p>
                </div> -->
                <div @mouseenter="showActive(1)" @mouseleave="showActive(0)" class="promise-box">
                    <img v-if="active==1" src="https://static.qyjmed.com/webSite/productService/maint/promise1.png" alt="">
                    <img v-else src="https://static.qyjmed.com/webSite/productService/maint/promise1-1.png" alt="">
                    <h2>服务响应时间</h2>
                    <p>周一至周日全天候24小时提供服务。<br>接到报修电话后15分钟内提供专业工程师电话支持。如需派工上门，1小时内确认派工信息和工程师到达医院所在地时间。自接报修电话始，专业工程师12小时内抵达故障现场。如遇特殊情况，与医院商议后可于24小时内到达故障现场。</p>
                </div>
                <div @mouseenter="showActive(2)" @mouseleave="showActive(0)" class="promise-box">
                    <img v-if="active==2" src="https://static.qyjmed.com/webSite/productService/maint/promise2.png" alt="">
                    <img v-else src="https://static.qyjmed.com/webSite/productService/maint/promise2-1.png" alt="">
                    <h2>客服中心</h2>
                    <p>我司拥有国内领先的客户服务中心，通过全国统一免费服务热线 “400-058-0200”为医院提供7×24小时热忱不间断的服务，每天值班人员≥2人。针对保修用户，提供一对一专人服务，处理协调公司与院方的各类工作，监督及评估驻场工程师的工作。此外，我司提供综合联络服务平台，医院可通过传真、WEB、信函、微信、全医佳设备管理平台等多种方式报修，满足医院关于业务报修、维修进度查询、故障申告、满意度反馈、投诉等多样化、个性化的服务需求。</p>
                </div>
                <div @mouseenter="showActive(3)" @mouseleave="showActive(0)" class="promise-box">
                    <img v-if="active==3" src="https://static.qyjmed.com/webSite/productService/maint/promise3.png" alt="">
                    <img v-else src="https://static.qyjmed.com/webSite/productService/maint/promise3-1.png" alt="">
                    <h2>定期维护保养</h2>
                    <p>针对保内设备每年提供4次定期维护保养，包括但不限于设备外观检查、性能检查、安全检查、影像质量检查、运行状态检查、清洁除尘保养、系统检测、系统备份、校准等。入保后一周内制定设备维护保养计划，并按照计划实施。每次保养前至少提前一周通知医院，具体保养实施时间根据医院具体情况商议确定。每次维护保养结束后，我司提供书面维护保养报告给医院。</p>
                </div>
                <div @mouseenter="showActive(4)" @mouseleave="showActive(0)" class="promise-box">
                    <img v-if="active==4" src="https://static.qyjmed.com/webSite/productService/maint/promise4.png" alt="">
                    <img v-else src="https://static.qyjmed.com/webSite/productService/maint/promise4-1.png" alt="">
                    <h2>检测维修</h2>
                    <p>设备发生故障时，我公司接到报修后，第一时间安排工程师以最快速度赶到故障现场，使设备及时恢复正常。在不涉及更换配件的情况下，36小时内排除故障并完成维修。
                        维修过程中需要更换零配件时，应向医院解释说明并快速调用配件。我司保证所提供的零配件是原厂配件，且配件来源及渠道具备合法性。每次维修完成后，工程师向院方提供书面维修报告一份。
                    </p>
                </div>
                <div @mouseenter="showActive(5)" @mouseleave="showActive(0)" class="promise-box">
                    <img v-if="active==5" src="https://static.qyjmed.com/webSite/productService/maint/promise5.png" alt="">
                    <img v-else src="https://static.qyjmed.com/webSite/productService/maint/promise5-1.png" alt="">
                    <h2>档案管理</h2>
                    <p>设备入保后，我司将针对VIP客户建立《医疗设备保修档案册》，该档案册每季度更新一次，其中包括保修合同、设备信息、保养维护报告、检测报告、维修报告、配件更换明细等，方便医院随时了解在保设备情况。</p>
                </div>
                <div @mouseenter="showActive(6)" @mouseleave="showActive(0)" class="promise-box">
                    <img v-if="active==6" src="https://static.qyjmed.com/webSite/productService/maint/promise6.png" alt="">
                    <img v-else src="https://static.qyjmed.com/webSite/productService/maint/promise6-1.png" alt="">
                    <h2>开机率保证</h2>
                    <p>保证保修期内开机率至少达到  95%  （按照365天/年）。开机率低于95%时，则每超过一天保修期顺延两天。</p>
                </div>
            </div>
        </div>
        <!-- 我们的优势 -->
        <div class="our-adv">
            <div class="container">
                <h2>我们的优势</h2>
                <div class="adv-box">
                    <div class="adv-content">
                        <img src="https://static.qyjmed.com/webSite/productService/maint/adv1.png" alt="">
                        <div @mouseenter="reserve=false" @mouseleave="reserve=true" class="img-content">
                            <p v-if="reserve">技术储备</p>
                            <div v-else>
                                <h2>技术储备</h2>
                                <p>围绕江苏全医佳综合服务平台，积极打造并参与各大行业联盟，与业内优秀企业和厂家形成长期战略联盟关系，能够快速获得业内技术更新与技术交流，形成坚实的技术储备网络，并不断实现维修技术水平的突破。</p>
                            </div>
                        </div>
                        <div class="adv-qua">
                            <div class="">
                                <img src="https://static.qyjmed.com/webSite/productService/maint/adv2.png" alt="">
                                <div @mouseenter="enginner=false" @mouseleave="enginner=true" class="enginner">
                                    <p v-if="enginner">工程师资质</p>
                                    <div v-else>
                                        <h2>工程师资质</h2>
                                        <p>在北京、上海和广州设立了主要配件库。同时打造国内及国外配件渠道网络，涵盖3000多家供应商，旨在为客户提供全面、经济、快速的配件，让客户省心省力省时。我们保证提供的配件渠道来源合法合规。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <img class="parts-img" src="https://static.qyjmed.com/webSite/productService/maint/adv3.png" alt="">
                                <div @mouseenter="parts=false" @mouseleave="parts=true" class="parts">
                                    <p v-if="parts">配件储备</p>
                                    <div v-else>
                                        <h2>配件储备</h2>
                                        <p>在北京，上海和广州设立了主要配件库。同时打造国内及国外配件渠道网络 ，涵盖3000多家供应商，旨在为客户提供全面，经济，快速的配件，让客户省心省力时。我们保证提供的配件渠道来源合法合规。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="adv-img">
                        <img src="https://static.qyjmed.com/webSite/productService/maint/adv4.png" alt="">
                        <div @mouseenter="inner=false" @mouseleave="inner=true" class="inner">
                            <p v-if="inner">工程师储备</p>
                            <div v-else>
                                <h2>工程师储备</h2>
                                <p>公司配备一支专业工程师团队，涵盖影像设备，内窥镜，呼吸麻醉，生化仪等多条产品线。所有工程师均受过系统完善的培训，80%的工程师曾服务于厂家或厂家授权维修站，平均行业经验超过5年。此外，我们还建立了全国工程师人才库，储备近6000名专业工程师，随时为全国的客户网络提供快速上门服务。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
import {WOW} from 'wowjs';
export default {
  name: 'maintenance',
  data(){
    return{
        option:[
            {
                img:'https://static.qyjmed.com/webSite/productService/maint/promise1-1.png',
                img1:'https://static.qyjmed.com/webSite/productService/maint/promise1.png',
                title:'服务响应时间',
                content:'周一至周日全天候24小时提供服务。<br>接到报修电话后15分钟内提供专业工程师电话支持。如需派工上门，1小时内确认派工信息和工程师到达医院所在地时间。自接报修电话始，专业工程师12小时内抵达故障现场。如遇特殊情况，与医院商议后可于24小时内到达故障现场。'
            },
            {
                img:'https://static.qyjmed.com/webSite/productService/maint/promise2-1.png',
                img1:'https://static.qyjmed.com/webSite/productService/maint/promise2.png',
                title:'客服中心',
                content:'我司拥有国内领先的客户服务中心，通过全国统一免费服务热线 “400-058-0200”为医院提供7×24小时热忱不间断的服务，每天值班人员≥2人。针对保修用户，提供一对一专人服务，处理协调公司与院方的各类工作，监督及评估驻场工程师的工作。此外，我司提供综合联络服务平台，医院可通过传真、WEB、信函、微信、全医佳设备管理平台等多种方式报修，满足医院关于业务报修、维修进度查询、故障申告、满意度反馈、投诉等多样化、个性化的服务需求。'
            },
            {
                img:'https://static.qyjmed.com/webSite/productService/maint/promise3-1.png',
                img1:'https://static.qyjmed.com/webSite/productService/maint/promise3.png',
                title:'定期维护保养',
                content:'针对保内设备每年提供4次定期维护保养，包括但不限于设备外观检查、性能检查、安全检查、影像质量检查、运行状态检查、清洁除尘保养、系统检测、系统备份、校准等。入保后一周内制定设备维护保养计划，并按照计划实施。每次保养前至少提前一周通知医院，具体保养实施时间根据医院具体情况商议确定。每次维护保养结束后，我司提供书面维护保养报告给医院。'
            },
            {
                img:'https://static.qyjmed.com/webSite/productService/maint/promise4-1.png',
                img1:'https://static.qyjmed.com/webSite/productService/maint/promise4.png',
                title:'检测维修',
                content:'设备发生故障时，我公司接到报修后，第一时间安排工程师以最快速度赶到故障现场，使设备及时恢复正常。在不涉及更换配件的情况下，36小时内排除故障并完成维修。维修过程中需要更换零配件时，应向医院解释说明并快速调用配件。我司保证所提供的零配件是原厂配件，且配件来源及渠道具备合法性。每次维修完成后，工程师向院方提供书面维修报告一份。'
            },
            {
                img:'https://static.qyjmed.com/webSite/productService/maint/promise5-1.png',
                img1:'https://static.qyjmed.com/webSite/productService/maint/promise5.png',
                title:'档案管理',
                content:'设备入保后，我司将针对VIP客户建立《医疗设备保修档案册》，该档案册每季度更新一次，其中包括保修合同、设备信息、保养维护报告、检测报告、维修报告、配件更换明细等，方便医院随时了解在保设备情况。'
            },
            {
                img:'https://static.qyjmed.com/webSite/productService/maint/promise6-1.png',
                img1:'https://static.qyjmed.com/webSite/productService/maint/promise6.png',
                title:'开机率保证',
                content:'保证保修期内开机率至少达到  95%  （按照365天/年）。开机率低于95%时，则每超过一天保修期顺延两天。'
            },
        ],
        active:0,
        reserve: true,
        enginner: true,
        parts: true,
        inner: true
    }
  },
  methods: {
      showActive:function(index){
          this.active = index;
      }
  },
  mounted() {
      var wow=new WOW({
          live: false
      })
      wow.init()
  },
  components: {
      Foot
  }
}
</script>

<style lang="scss" scoped>
    .maint{
        .banner-img{
            background: url('https://static.qyjmed.com/webSite/productService/maint/banner-img.png') center;
            height: 562px;
            margin-top: $highlight-height;
            position: relative;
            .container{
                .soft-img{
                    position: absolute;
                    bottom: 30px;
                    .soft{
                        width: 300px;
                        height: 80px;
                        display: inline-block;
                        border-left: 2px solid #ffffff44;
                        img{
                            vertical-align: text-bottom;
                            padding-left: 50px;
                        }
                        p{
                            display: inline-block;
                            font-size: 18px;
                            color: white;
                            height: 80px;
                            margin-left: 34px;
                            vertical-align: middle;
                        }
                        &:last-child{
                            border-right: 2px solid #ffffff44;
                        }
                    }
                }
            }
        }
        .cc{
            .container{
                .cc-box{
                    margin-top: 130px;
                    .cc-text{
                        width: 600px;
                        height: 490px;
                        display: inline-block;
                        vertical-align: top;
                        background-image: url('https://static.qyjmed.com/webSite/aboutUs/cc/text-bg.png');
                        p{
                            font-size: 18px;
                            color: #333333;
                            line-height: 36px;
                            text-indent: 2rem;
                            padding:0 60px 0 0;
                            &:nth-child(2){
                                margin-top: 30px;
                                margin-bottom: 30px;
                            }
                        }
                        i{
                            width: 47px;
                            height: 7px;
                            display: block;
                            background-color: #79AAF4;
                        }

                    }
                    .cc-img{
                        width: 600px;
                        display: inline-block;
                    }
                }
            }
        }
        // 分类
        >h2{
            font-size: 30px;
            color: #1B212B;
            text-align: center;
            margin:78px 0 68px;
            font-weight: 400;
        }
        .classfiy{
            background: url('https://static.qyjmed.com/webSite/productService/maint/number-bg.png') no-repeat;
            .container{
                text-align: center;
                .classfiy-box{
                    width: 400px;
                    display: inline-block;
                    vertical-align: top;
                    padding-bottom: 100px;
                    img{
                        margin-top: 20px;
                    }
                    h2{
                        margin:24px 0;
                        font-size: 16px;
                        color:#333333;
                    }
                    p{
                        font-size: 16px;
                        color: #000;
                        width: 240px;
                        margin:0 auto;
                        line-height: 26px;
                        letter-spacing: 1px;
                    }
                }
            }
        }
        // 服务承诺
        .promise{
            background-color: #F7F8FA;
            .container{
                >h2{
                    padding:62px 0 36px;
                    text-align: center;
                    color: #1B212B;
                    font-size: 30px;
                    font-weight: 400;
                }
                .promise-box{
                    width: 390px;
                    height: 664px;
                    background-color: white;
                    display: inline-block;
                    vertical-align: top;
                    text-align: center;
                    margin-bottom: 30px;
                    img{
                        margin-top: 46px;
                    }
                    h2{
                        text-align: center;
                        margin:28px 0 32px;
                        font-weight: 400;
                    }
                    p{
                        text-align: left;
                        padding:0 26px;
                        font-size: 18px;
                        line-height: 36px;
                        color: #333;
                    }
                    &:nth-child(3n+3){
                        margin:0 15px;
                    }
                    &:hover{
                        background: #4497DD;
                        color: white;
                        p{
                            color: white;
                            // transition: 0.5s;
                        }
                    }
                }
            }
        }
        // 我们的优势
        .our-adv{
            .container{
                h2{
                    padding:46px 0 56px;
                    color: #1B212B;
                    font-size: 30px;
                    text-align: center;
                }
                .adv-box{
                    margin-bottom: 10px;
                    .adv-content{
                        width: 790px;
                        margin-right: 30px;
                        display: inline-block;
                        vertical-align: top;
                        >img{
                            position: absolute;
                        }
                        .img-content{
                            position: relative;
                            height: 278px;
                            text-align: center;
                            font-size: 24px;
                            line-height: 278px;
                            color: white;
                            cursor: pointer;
                            div{
                                animation: pulse 1s;
                                height: 278px;
                                background: url('https://static.qyjmed.com/webSite/productService/maint/adv2-1.png');
                                h2{
                                    font-size: 24px;
                                    padding:20px 0;
                                    line-height: 30px;
                                    color: white;
                                    font-weight: 400;
                                }
                                p{
                                    font-size: 18px;
                                    line-height: 36px;
                                    padding: 0 16px;
                                }
                            }
                        }
                        .adv-qua{
                            margin-top: 26px;
                            img:first-child{
                                margin-right: 29px;
                                position: absolute;
                            }
                            >div{
                                display: inline-block;
                                width: 381px;
                                &:first-child{
                                    margin-right: 28px;
                                }
                            }
                            .enginner{
                                position: relative;
                                width: 381px;
                                height: 278px;
                                display: inline-block;
                                line-height: 278px;
                                margin-right: 29px;
                                vertical-align: top;
                                text-align: center;
                                font-size: 24px;
                                color: white;
                                cursor: pointer;
                                div{
                                    animation: rotateInUpRight 1s;
                                    height: 278px;
                                    background: url('https://static.qyjmed.com/webSite/productService/maint/adv2-1.png');
                                    h2{
                                        font-size: 24px;
                                        padding:20px 0;
                                        line-height: 30px;
                                        color: white;
                                        font-weight: 400;
                                    }
                                    p{
                                        font-size: 18px;
                                        line-height: 36px;
                                        padding: 0 16px;
                                    }
                                }
                            }
                            .parts-img{
                                position: absolute;
                            }
                            .parts{
                                position: relative;
                                width: 381px;
                                height: 278px;
                                display: inline-block;
                                line-height: 278px;
                                vertical-align: top;
                                text-align: center;
                                font-size: 24px;
                                color: white;
                                cursor: pointer;
                                div{
                                    animation: rotateInUpRight 1s;
                                    background: url('https://static.qyjmed.com/webSite/productService/maint/adv2-1.png');
                                    height: 278px;
                                    h2{
                                        font-size: 24px;
                                        padding:20px 0;
                                        line-height: 30px;
                                        color: white;
                                        font-weight: 400;
                                    }
                                    p{
                                        font-size: 18px;
                                        line-height: 36px;
                                        padding: 0 16px;
                                    }
                                }
                            }
                        }
                    }
                    .adv-img{
                        width: 380px;
                        display: inline-block;
                        img{
                            position: absolute;
                        }
                        .inner{
                            position: relative;
                            width: 380px;
                            height: 586px;
                            line-height: 586px;
                            text-align: center;
                            font-size: 24px;
                            cursor: pointer;
                            vertical-align: top;
                            color: white;
                            div{
                                animation: pulse 1s;
                                height: 586px;
                                background: url('https://static.qyjmed.com/webSite/productService/maint/adv4-1.png');
                                h2{
                                    font-size: 24px;
                                    padding:20px 0;
                                    line-height: 30px;
                                    color: white;
                                    font-weight: 400;
                                }
                                p{
                                    font-size: 18px;
                                    line-height: 36px;
                                    padding: 0 16px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
